import { render } from "./social_home.vue?vue&type=template&id=76424346&scoped=true"
import script from "./social_home.vue?vue&type=script&lang=js"
export * from "./social_home.vue?vue&type=script&lang=js"

import "./social_home.vue?vue&type=style&index=0&id=76424346&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76424346"]])

export default __exports__